// extracted by mini-css-extract-plugin
module.exports = {"DialogItem":"styles_DialogItem__8oCnv","IsExpanding":"styles_IsExpanding__bmLDw","Red":"styles_Red__1dgIw"};